import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-800236e4"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "outer"
}
const _hoisted_2 = ["controls", "loop", "muted", "autoplay"]
const _hoisted_3 = ["src"]
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" 对不起，本浏览器不支持视频播放 ")
const _hoisted_5 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.img)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", {
          class: "timage_wrap oneImg",
          style: _normalizeStyle(_ctx._style)
        }, [
          (_ctx.isVideo)
            ? (_openBlock(), _createElementBlock("video", {
                key: 0,
                marker: "tiger",
                controls: _ctx.controls,
                loop: _ctx.loop,
                muted: _ctx.muted,
                autoplay: _ctx.autoplay,
                class: "_timage _tvideo",
                alt: ""
              }, [
                _createElementVNode("source", {
                  src: _ctx.img,
                  type: "video/mp4"
                }, null, 8, _hoisted_3),
                _hoisted_4
              ], 8, _hoisted_2))
            : _createCommentVNode("", true),
          (!_ctx.isVideo)
            ? (_openBlock(), _createElementBlock("img", {
                key: 1,
                src: _ctx.img,
                class: "_timage",
                alt: ""
              }, null, 8, _hoisted_5))
            : _createCommentVNode("", true),
          (true || _ctx.randomIndex % 4 == 0)
            ? (_openBlock(), _createElementBlock("div", {
                key: 2,
                class: "decor_vert decor1_1",
                style: _normalizeStyle(`background-color:${_ctx.decorColor>-1?_ctx.randomColors[_ctx.decorColor]:_ctx.randomColors[0]}`)
              }, null, 4))
            : _createCommentVNode("", true),
          (true || _ctx.randomIndex % 4 == 0)
            ? (_openBlock(), _createElementBlock("div", {
                key: 3,
                class: "decor_hori decor1_2",
                style: _normalizeStyle(`background-color:${_ctx.decorColor>-1?_ctx.randomColors[_ctx.decorColor]:_ctx.randomColors[0]}`)
              }, null, 4))
            : _createCommentVNode("", true)
        ], 4)
      ]))
    : _createCommentVNode("", true)
}